import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, ExpenseVouchersController, ExpenseVouchersRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'expensesreport',
  templateUrl: './expensesreport.component.html',
  styleUrls: ['./expensesreport.component.scss']
})

export class ExpensesreportPVComponent implements OnInit {

    public ApiResData: ApiResponseModel;
    public isRequesting: boolean = false;

  public Date: Date;
  public SelectedDay: any;
  public SelectedMonth: any;
  public SelectedYear: any;
    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;
    ScanDate: NgbDateStruct;
    SelectedFromDate: NgbDateStruct;
  pdata: any[];

  CurrentExpenseVouchersController: ExpenseVouchersController[];
  CurrentExpenseVouchersRequest: ExpenseVouchersRequest;

  LoadForms() {
    this.CurrentExpenseVouchersRequest = new ExpenseVouchersRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentExpenseVouchersRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentExpenseVouchersController;
    // this.pdata = this.CurrentFollicularScansBetweenDateController;
    this.GetExpenseVouchersController();
  }
  //public SelectedReport: string;

  GetExpenseVouchersController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentExpenseVouchersRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentExpenseVouchersRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentExpenseVouchersRequest.ToDate = new Date();
    this.CurrentExpenseVouchersRequest.ConditionalOperator = 20;
    //alert(this.FormattedCode);
    this.actorservice.GetExpenseVouchersController(this.CurrentExpenseVouchersRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentExpenseVouchersController = this.ApiResData.Result;
          this.pdata = this.CurrentExpenseVouchersController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          this.LoadOqaData();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

    CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
    CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;
    OocyteStorageDetails: IvfOocyteEmbryoStorageByCodeController;
    LoadOqaData() {
        //alert("ScansData")
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        //this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        //this.ActorCode = this.route.snapshot.paramMap.get('ActorCodedata');
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfOocyteEmbryoStorageByCodeController();
    }

    GetIvfOocyteEmbryoStorageByCodeController() {
        this.StartRefreshing();

        //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
        //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.TreatmentCycleCode;
        //this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.ActorCode;
        this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;


                    this.stopRefreshing();
                    this.printService.onDataReady();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    constructor(private router: Router,
        private actorservice: ActorService,
        private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
        private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
        private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

        public printService: PrintService) {


    }


    ngOnInit() {
        //alert("in scans comp");
      this.Date = new Date();
      this.SelectedDay = this.route.snapshot.paramMap.get('Day');
      this.SelectedMonth = this.route.snapshot.paramMap.get('month');
      this.SelectedYear = this.route.snapshot.paramMap.get('year');
      this.SelectedFromDate = { year: this.SelectedYear, month: this.SelectedMonth, day: this.SelectedDay };

      this.LoadForms();


    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

}








